import * as React from 'react';
import * as appDom from '../../appDom';

export default React.createContext<appDom.ElementNode | undefined>(undefined);
